import { createRoute } from '@tanstack/react-router';
import { LegendPage } from '@/features/legend/LegendPage';
import { Route as shellRoute } from '../_shell';

/** Every definition the Stock overview uses, with its version, unit, basis and sources. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/legend',
  component: LegendPage,
});
